﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1.

export const cdnUrl = "https://sbb-rsucdn.azurewebsites.net";
export const appName = "SiVe";
export const dateFormat = "dd.MM.yyyy";
export const datePickerPlaceholder = "TT.MM.JJJJ";
export const dateRangeFormat = "dd.MM.yyyy - dd.MM.yyyy";
export const dateTimeFormat = "dd.MM.yyyy HH:mm";
export const dateTimeRangeFormat = "dd.MM.yyyy HH:mm - dd.MM.yyyy HH:mm";
export const dayOfWeekDateFormat = "EEEE, dd.MM.yyyy";
export const ellipsis = "…";
export const noAccessStrictlyConfidential = "NoAccessStrictlyConfidential";
export const systemUserId = "000000";
export const systemUserUpn = "SYSTEM";
export const timeFormat = "HH:mm";
export const userPickerDelete = "UserPickerDelete";
export const meetingTemplateEmpty = -10;
export const meetingTemplateImported = -20;
